<div [appCard]="{ paddingTop: '25px' }" dirBorder="tiny" [cardShadow]="false" class="relative">
 @if (inputData.closeButton) {
  @if (useClassicComponents) {
  <app-button
    class="absolute z-1 top-[var(--padding-small)] right-[var(--padding-small)]"
    icon="close"
    iconSize="30px"
    iconColor="--primary-secondary"
    [iconViewBoxAdjustmentX]="9"
    [iconViewBoxAdjustmentY]="9"
    (click)="dialogRef.close()"
  />
  }
  @else {
  <button
    class="so-alert-modal__close flex absolute z-1"
    type="button"
    aria-label="Cerrar"
    (click)="dialogRef.close()"
  >
    <span class="material-icons">close</span>
  </button>
  }
 }
  <ng-container *ngComponentOutlet="inputData.component; inputs: inputData.inputs"></ng-container>
</div>
